/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import { useLazyQuery, useDataFetchingClient } from 'data-fetching-client';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import getIn from 'immutable-less/transmute/getIn';
import DataSource from 'automation-ui-formula-editor/fetch-object-panel/containers/DataSource';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { AddIcon } from 'foundations-assets';
import { ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import SelectDataSourceFetchObjects from 'automation-ui-formula-editor/fetch-object-panel/containers/SelectDataSourceFetchObjects';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useState } from 'react';
import { REMOVE_DATA_SOURCE } from 'automation-ui-formula-editor/data-sources/queries/removeDataSourceQuery';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { useDataSourcesContext } from 'automation-ui-formula-editor/data-sources/DataSourcesContext';
import { FETCHED_OBJECTS } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { useGetDataSource } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSource';
import { GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME, GET_DATA_SOURCES_BY_PREFIX_FIELD_NAME } from 'automation-ui-formula-editor/data-sources/queries/getPrefixQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectDataSource = ({
  onDataSourceDelete,
  onDataSourceEdit,
  onClickAddDataSource,
  isFlowEnabled = false
}) => {
  const [sourceToRemove, setSourceToRemove] = useState(null);
  const [deleteDataSource, {
    called: deleteDataSourceCalled,
    loading: deleteDataSourceLoading
  }] = useLazyQuery(REMOVE_DATA_SOURCE);
  const client = useDataFetchingClient();
  const {
    data: fetchedObjectsDataSource,
    loading: fetchedObjectsDataSourceLoading,
    error: fetchedObjectsDataSourceError
  } = useGetDataSource({
    prefix: FETCHED_OBJECTS
  });
  const {
    flowId,
    flowObjectTypeId
  } = useDataSourcesContext();
  useEffect(() => {
    if (!deleteDataSourceCalled || deleteDataSourceLoading || !sourceToRemove) {
      return;
    }
    setSourceToRemove(null);
    const prefix = getIn(['dataSourceDefinition', 'name'], sourceToRemove);

    // force a refetch of the affected queries
    client.cache.evict({
      fieldName: GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME,
      broadcast: true,
      args: {
        flowId,
        flowObjectTypeId,
        prefix,
        query: {}
      }
    });
    client.cache.evict({
      fieldName: GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME,
      broadcast: true,
      args: {
        flowId,
        flowObjectTypeId,
        prefix: FETCHED_OBJECTS,
        query: {}
      }
    });
    client.cache.evict({
      fieldName: GET_DATA_SOURCES_BY_PREFIX_FIELD_NAME,
      broadcast: true
    });
    if (onDataSourceDelete) {
      onDataSourceDelete({
        deletedDataSourceName: prefix
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteDataSourceCalled, deleteDataSourceLoading]);
  const onRemove = useCallback(() => {
    if (!sourceToRemove) {
      return;
    }
    const dataSourceId = Number(getIn(['dataSourceDefinition', 'metadata', 'dataSourceId'], sourceToRemove));
    if (isNaN(dataSourceId) || dataSourceId <= 0) {
      return;
    }
    deleteDataSource({
      variables: {
        flowId,
        dataSourceId
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceToRemove, setSourceToRemove]);
  const RemoveButton = useCallback(({
    onClick: onLoadingFinish
  }) => {
    return /*#__PURE__*/_jsx(UILoadingButton, {
      loading: deleteDataSourceLoading,
      use: "danger",
      onClick: onRemove,
      onLoadingFinish: onLoadingFinish,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.action.remove"
      })
    });
  }, [deleteDataSourceLoading, onRemove]);
  return /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.label.available-data"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h6",
      marginBlockStart: "500",
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.label.enrolled-record"
      })
    }), /*#__PURE__*/_jsx(DataSource, {
      dataSourceToView: {
        prefix: ENROLLED_OBJECT
      }
    }), sourceToRemove && /*#__PURE__*/_jsx(UIConfirmModal, {
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.label.remove-prompt"
      }),
      confirmUse: "danger",
      description: isFlowEnabled ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.label.remove-confirm.enabled_jsx",
        elements: {
          Bold: 'b'
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.label.remove-confirm.disabled"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.label.remove-prompt"
      }),
      size: "auto",
      use: "danger",
      onConfirm: () => setSourceToRemove(null),
      onReject: () => setSourceToRemove(null),
      ConfirmButton: RemoveButton,
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.action.cancel"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h6",
      marginBlockStart: "500",
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.label.additional-records"
      })
    }), /*#__PURE__*/_jsx(SelectDataSourceFetchObjects, {
      onRemove: dataSource => {
        if (dataSource) {
          setSourceToRemove(dataSource);
        }
      },
      onEdit: onDataSourceEdit,
      dataSourceDefinition: fetchedObjectsDataSource ? fetchedObjectsDataSource.dataSourceDefinition : {},
      loading: fetchedObjectsDataSourceLoading,
      dataSourceErrored: !!fetchedObjectsDataSourceError
    }), /*#__PURE__*/_jsxs(Button, {
      use: "link",
      onClick: onClickAddDataSource,
      "data-test-id": "add-data-source-button",
      marginBlockStart: "300",
      children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.search-properties-top-panel.add-data-btn-text"
      })]
    })]
  });
};
export default SelectDataSource;